// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://oyxiezzdlkmqrvaoorjk.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im95eGllenpkbGttcXJ2YW9vcmprIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzc2NjUyNzYsImV4cCI6MjA1MzI0MTI3Nn0.DfWd26y1tq5Q5zdhpea6Ap2nzppjammyEdGt0wLdOQM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);